import { render, staticRenderFns } from "./DashboardGroup.vue?vue&type=template&id=08207270&"
import script from "./DashboardGroup.vue?vue&type=script&lang=js&"
export * from "./DashboardGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports